import { useQuery } from 'react-query'

import { OrderItem } from '@webapp/modules/purchasing/entities/OrderItem'
import { orderItemQueryConfig } from '@webapp/modules/purchasing/query-configs/orderItem'

export const useQueryPurchasingList = () => {
  const { data, isFetching } = useQuery(
    orderItemQueryConfig.getPurchasingListItems()
  )

  return {
    orderItems: data?.map((orderItem) => new OrderItem(orderItem)),
    isFetching,
  }
}
